var _title, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoCircleci = function SvgLogoCircleci(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "CircleCI")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.023 18.916C8.038 10.917 15.196 5 23.726 5 33.818 5 42 13.283 42 23.5 42 33.716 33.818 42 23.726 42c-8.532 0-15.69-5.919-17.704-13.919A.83.83 0 0 1 6 27.906c0-.488.39-.882.87-.882h7.366c.35 0 .65.212.789.515l.001-.002c1.514 3.336 4.837 5.655 8.7 5.655 5.285 0 9.572-4.34 9.572-9.692 0-5.351-4.287-9.691-9.572-9.691-3.863 0-7.188 2.318-8.701 5.653a.871.871 0 0 1-.79.514H6.87a.875.875 0 0 1-.87-.88c0-.062.01-.122.023-.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.726 19.096c-2.402 0-4.351 1.972-4.351 4.404s1.949 4.406 4.351 4.406c2.403 0 4.35-1.974 4.35-4.406 0-2.432-1.947-4.404-4.35-4.404Z"
  })));
};
export default SvgLogoCircleci;